import { render, staticRenderFns } from "./GridHistory.vue?vue&type=template&id=f68b34bc"
import script from "./GridHistory.vue?vue&type=script&lang=js"
export * from "./GridHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports